import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.jsx';
import 'semantic-ui-css/semantic.min.css'
import './scss/global.scss'
import { ThemeProvider } from '@mui/material/styles';
import {Provider} from 'react-redux'
import generateStore from './redux/store'
import { Theme } from './Theme/Theme';
import UsuarioProvider from './context/UsuarioProvider';
import ErrorBoundary from './ErrorBoundaryChact';
const store = generateStore()



const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
   <React.StrictMode>
     <UsuarioProvider>
    <ThemeProvider theme={Theme}>

    <Provider store={store}>
      <App />
    </Provider>
 
    </ThemeProvider>
    </UsuarioProvider>
  </React.StrictMode>, rootElement);
} else {
  ReactDOM.render( 
  <React.StrictMode>
    <UsuarioProvider>
    <ThemeProvider theme={Theme}>

    <Provider store={store}>
      <App />
    </Provider>
  
    </ThemeProvider>
    </UsuarioProvider>
  </React.StrictMode>, rootElement);
}
